module.exports = __webpack_public_path__ + "static/media/js.ca64d02c.svg";